function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M33.819 27.621c0-.99 0-2.075-.023-3.265a15.959 15.959 0 0 0-.62-4.459 8.662 8.662 0 0 0-3.544-4.708c-5.157-3.346-10.7.642-12.28 1.972a3.793 3.793 0 0 0-.442.3 3.788 3.788 0 0 0-.442-.3c-1.581-1.33-7.123-5.317-12.28-1.972a8.662 8.662 0 0 0-3.544 4.708 15.962 15.962 0 0 0-.62 4.459c-.019 1.19-.027 2.275-.023 3.265-.019 5.049.284 7.587 1.049 8.855.945 1.7 2.587 1.189 5.16 1.219h.109a.819.819 0 0 0 .819-.819v-9.562a2.859 2.859 0 0 1 2.851-2.851 2.859 2.859 0 0 1 2.851 2.851v8.678a1.7 1.7 0 0 0 1.7 1.7h4.685a1.644 1.644 0 0 0 1.644-1.644v-8.672a2.9 2.9 0 0 1 2.57-2.9 2.858 2.858 0 0 1 3.131 2.837v9.454a.927.927 0 0 0 .927.927h.109c2.573-.03 4.215.483 5.16-1.219.769-1.267 1.072-3.805 1.053-8.854z"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 4.025,
  cy: 4.025,
  r: 4.025,
  transform: "translate(20.976 3.466)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.795,
  cy: 1.795,
  r: 1.795,
  transform: "translate(28.019)"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 4.025,
  cy: 4.025,
  r: 4.025,
  transform: "translate(4.742 3.466)"
});

function SvgMelhorIdadeLogoMin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.819,
    height: 37.745,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelhorIdadeLogoMin);
export default __webpack_public_path__ + "static/media/melhor_idade_logo_min.c7f8154d.svg";
export { ForwardRef as ReactComponent };